import '@tylertech/forge/card';
import type { ProjectKpis } from '../../lib/projectDashboard';
import './ProjectKpiCards.css';

export interface ProjectKpiCardsProps {
  kpis: ProjectKpis;
}

const CardElement = 'forge-card' as React.ElementType;

export function ProjectKpiCards({ kpis }: ProjectKpiCardsProps): JSX.Element {
  return (
    <div className="kpi-cards">
      <CardElement className="kpi-card">
        <div className="kpi-card-inner">
          <span className="kpi-label forge-typography--caption">Milestones Complete</span>
          <span className="kpi-value forge-typography--headline5">
            {kpis.milestonesComplete} / {kpis.milestonesTotal}
          </span>
        </div>
      </CardElement>

      <CardElement className="kpi-card">
        <div className="kpi-card-inner">
          <span className="kpi-label forge-typography--caption">Services Assigned</span>
          <span className="kpi-value forge-typography--headline5">{kpis.servicesAssigned}</span>
        </div>
      </CardElement>

      <CardElement className="kpi-card">
        <div className="kpi-card-inner">
          <span className="kpi-label forge-typography--caption">Done</span>
          <span className="kpi-value forge-typography--headline5">{kpis.pctDone}%</span>
        </div>
      </CardElement>

      <CardElement className="kpi-card">
        <div className="kpi-card-inner">
          <span className="kpi-label forge-typography--caption">Assignments Done</span>
          <span className="kpi-value forge-typography--headline5">{kpis.assignmentsDone}</span>
        </div>
      </CardElement>
    </div>
  );
}
